import "./index.scss";
import zcclogo from "../../../../assets/top-logo.png";
import titleimg from "../../../../assets/title-img.png"
import { useState } from "react";
import { useNavigate } from "react-router-dom"
function Header(props) {
  const navigate = useNavigate();
  function toBckj() {
    window.open("https://www.bcnpl.com", "_blank");
  }
  function logozcc() {
    window.open("https://recheck.bczcc.com/login", "_blank");
  }
  function toHome() {
    navigate("/")
  }
  return (
    <div className="about-header-container">
      <div className="nav-row top-row" style={{ backgroundColor: props.navBgc, boxShadow: props.shadow }}>
        <div className="logo-left">
          <div className="nav-item">
            <img className="logo-img" src={zcclogo} />
          </div>
        </div>
        <div className="login-right">
          <div className="nav-item layout" onClick={toHome}>再查查</div>
          <div className="nav-item layout txt-home-page" >关于我们</div>
          <div className="nav-item layout" onClick={toBckj}>
            集团官网
          </div>
          <div className="nav-item layout" onClick={logozcc}>
            登录
          </div>
        </div>
      </div>
      <div className="banner-info">
        <div>
          <img className="title-img" src={titleimg} />
        </div>
        <div className="title">智能风险管理及线索查控SaaS系统</div>
      </div>

    </div>
  );
}
export default Header;
